export default {
    user_subsidiary: null,
    subsidiaries: [],
    products_by_subsidiary: [],
    rent_operations: []
}